import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, HostListener } from '@angular/core';
import { DateFilterComponent } from '../../ui/date-filter/date-filter.component';
import * as moment from 'moment';
import * as XLSX from 'xlsx';
import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { UsersService } from 'src/app/private/services/users.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { openCustomerActivityCaptureForm } from 'src/app/utils/customer-activity-capture-form.util';
@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {
  modalRef:any;
  isExcelImportOpen = true;
  mobileMenuVisible = false;
  DateFilterComponent = DateFilterComponent;
  showFilter: boolean = false;
  @Input() showBulkFilter: boolean = false;
  @Input() showSearch: boolean = true;
  activeFilter: string = 'gender';
  FilterdateStart: Date = new Date();
  selectedFilterType:any = "text"
  Filterdateend: Date = new Date();
  /** Separate from lead_date range — used only for custom JSON date fields (e.g. Deadline). */
  customFieldDateStart: Date = new Date();
  customFieldDateEnd: Date = new Date();
  isActive: string = 'Add New';
  isGroupActive: string = '';
  filterType: any = "";
  SearchInput: any;
  errorMsg: any;
  isToggled: boolean = false;
  isOpen: boolean = false;
  viewText: string = 'Kanban View';
  /** Customer activity capture / simulator — client 4 only. */
  showSimulatorButton = false;
  @Input() breadcrumbArray: any[] = [];



  @Input() topBarTitle !: string;
  @Input() simpleSearch = false;
  @Output("create") Create: EventEmitter<any> = new EventEmitter();
  @Output("ExportData") ExportData: EventEmitter<any> = new EventEmitter();
  @Output("ResetDateFilter") ResetDateFilter: EventEmitter<any> = new EventEmitter();
  @Output("ResetFilter") ResetFilter: EventEmitter<any> = new EventEmitter();
  @Output("DateFilter") DateFilter: EventEmitter<any> = new EventEmitter();
  @Output("searchFilter") searchFilter: EventEmitter<any> = new EventEmitter();
  @Output("openList") openList: EventEmitter<any> = new EventEmitter();
  @Output("downLoadSample") downLoadSample: EventEmitter<any> = new EventEmitter();
  @Output("sendImportData") sendImportData: EventEmitter<any> = new EventEmitter();
  @Input() title = "";
  @Input() isDatefilter = false;
  /** When true (Leads), clearing the global date range does not wipe custom JSON date filters — parent merges partial payloads. */
  @Input() mergeDateFilterPayloads = false;
  @Input() isExport = false;
  @Input() isAdd = false;
  @Input() filterArray: any = [];
  @Input() importStatus: boolean = false;
  @Input() SelectedLeadSpace: any = "";
  @Input() initialLoad: boolean = false;
  @Input() displayedColumns?: any = [];
  @Input() importColumnsArray: any = [];
  @Input() allLeadFeilds: any = [];
  @Input() bulkLeadFilterLoading: boolean = false;
  @Input() bulkSelectionActive: boolean = false;
  @Input() teams: any[] = [];
  @Input() needToConnectOutlook: boolean = false;
  @Output() handleShowCanban = new EventEmitter();
  @Output() applyLeadBulkFilter = new EventEmitter();
  @Output() clearLeadBulkFilter = new EventEmitter();
  @Output() connectCommunication = new EventEmitter();
  toggleView() {
    if (this.initialLoad) return;
    this.isToggled = !this.isToggled;
    this.viewText = this.isToggled ? 'List View' : 'Kanban View';
    this.mobileMenuVisible = false
    if (this.isToggled) {
      this.handleShowCanban.emit(true);
    } else {
      this.handleShowCanban.emit(false);
    }
  }

  @Input() isContactGroups = false;

  @Input() isRefresh = false;
  @Output() refresh = new EventEmitter();
  @Input() exportArray: any = [];
  @Input() isExportLoading = false;
  @Input() isImport = false;
  @Input() filterData = [];
  @Input() filters: any = [];
  check_true: boolean = false;
  filterCol: any = [];
  users: any = [];
  importDataArray: any = [];
  actionButton: any = "search"
  toggleExport: boolean = false;
  toggleDropDown: boolean = false;
  toggleDropDownType: any = "";
  dynamicDropdownOptions: any[] = [];
  dynamicDropDownKey: string = '';
  dynamicDropdownSelection = '';
  dynamicDropdownPlaceholder = 'Select';
  /** When true, toolbar date range filters a custom JSON date field (e.g. deadline), not lead_date. */
  isCustomDateFieldSearch = false;
  /** Set synchronously on change so deadline filter always knows the JSON field key (avoids ngModel race). */
  activeCustomDateFieldKey = '';

  // selectedFilterKey: string = '';
  // selectedFilterValue: string = '';

  // userOptions: any[] = [];
  // teamOptions: any[] = [];
  // createdByOptions: any[] = [];
  constructor(private modalService: NgbModal, private toast: ToastrService, private localStorage: LocalStorageService, private userApi: UsersService,
    private router: Router
  ) { }
  ngOnInit(): void {
    this.getAllUsers();
    this.showSimulatorButton = String(this.localStorage.getClientId() ?? '').trim() === '4';
    console.log(this.filterData)
  }
  openImport(content: any): void {
    //console.log(this.SelectedLeadSpace)
    this.isExcelImportOpen = true;
    this.modalRef = this.modalService.open(content, {
      size: 'lg', scrollable: false,
      centered: true
    });

    this.modalRef.result.then(
      () => this.resetModalState(),
      () => this.resetModalState()
    );
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['isExportLoading']) {
      if (this.isExportLoading == true) {
        //alert(`Received Data: ${this.isExportLoading}`);
        this.filterCol = []
      }


    }
    // this.getDynamicFilterOptions();
  }
  // getDynamicFilterOptions() {
  //   if (this.users && this.users.length) {
  //     this.userOptions = this.users.map(user => ({
  //       id: user.user_id,
  //       name: `${user.fname} ${user.lname}`
  //     }));
  //     this.createdByOptions = this.userOptions; // assuming same user list for created_by
  //   }

  //   if (this.teams && this.teams.length) {
  //     this.teamOptions = this.teams.map(team => ({
  //       id: team.team_id,
  //       name: team.name
  //     }));
  //   }
  // }

  // getOptionsForKey(key: string): any[] {
  //   switch (key) {
  //     case 'user_id':
  //       return this.userOptions;
  //     case 'team_id':
  //       return this.teamOptions;
  //     case 'created_by':
  //       return this.createdByOptions;
  //     default:
  //       return [];
  //   }
  // }

  // onFilterValueChange() {
  //   if (this.selectedFilterKey && this.selectedFilterValue) {
  //     this.searchFilter.emit({
  //       key: this.selectedFilterKey,
  //       value: this.selectedFilterValue
  //     });
  //   }
  // }



  clearFilterColumn() {
    this.filterCol = [];
  }

  downloadSampleExcel() {
    this.downLoadSample.emit()
  }

  Refresh() {
    this.refresh.emit();
  }


  toggleExportFn() {

    if(this.topBarTitle == 'User Logs') {
      this.exportExcel();
      return;
    }

    this.toggleExport = (this.toggleExport) ? false : true

    if (this.toggleExport) {
      this.isActive = 'Export'
    }
  }
  getAllUsers() {
    let param = {
      client_id: this.localStorage.getClientId(),
    };
    this.userApi.findAllUsers(param).subscribe({
      next: (res: any) => {
        this.users = res || [];
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }
  addFilterCol(event: any, i: any) {
    if (event.target.checked) {
      this.filterCol.push({ key: i, value: event.target.value })
    }
    else {
      this.filterCol = this.filterCol.filter(((item: any) => item.key != i))
    }
  }
  fnSelectAll(event: any) {
    var checkboxes: any = document.getElementsByClassName('filter_check');
    if (event.target.checked) {

      for (var i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].type == 'checkbox') {
          console.log(checkboxes.length)
          checkboxes[i].checked = true;
          this.filterCol.push({ key: i, value: checkboxes[i].value })
        }
      }
    }
    else {
      for (var i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].type == 'checkbox') {
          checkboxes[i].checked = false;
        }
      }
      this.filterCol = [];
    }
  }

  TypeToFilter(event: any) {
    // alert(event.target.value)
    let object: any = {}
    object['lead_type'] = event.target.value;
    object['user_id'] = event.target.value;
    object['team_id'] = event.target.value;
    object['created_by'] = event.target.value;
    this.searchFilter.emit(object);
  }
  LeadStatusFilter(event: any) {
    let object: any = {}
    object['lead_status'] = event.target.value;
    this.searchFilter.emit(object);
  }
  searchByFilterQuery(event: any, type: any) {
    if (!event.target.value) {
      return;
    }
    let object: any = {}
    object[type] = event.target.value;
    this.searchFilter.emit(object);
    this.mobileMenuVisible = false;
  }
  private fieldTypeIsDate(t: any): boolean {
    const s = String(t ?? '').toLowerCase();
    return s === 'date' || s === 'datetime';
  }

  private fieldTypeIsSelect(t: any): boolean {
    return String(t ?? '').toLowerCase() === 'select';
  }

  private isDateFieldFilterOption(key: string): boolean {
    if (!key) {
      return false;
    }
    const f = this.filterArray.find((fl: any) => fl.key === key);
    return this.fieldTypeIsDate(f?.type);
  }

  private exitCustomFieldDateSearch() {
    this.isCustomDateFieldSearch = false;
    this.activeCustomDateFieldKey = '';
    this.toggleDropDownType = '';
    this.customFieldDateStart = new Date();
    this.customFieldDateEnd = new Date();
    this.DateFilter.emit({ dynamicFieldDateFilter: null });
  }

  changeFilter(event: any) {
  


    this.isActive = 'Filter'
    this.toggleExport = false;
    const newKey = event.target.value;
    if (this.isCustomDateFieldSearch && !this.isDateFieldFilterOption(newKey)) {
      this.exitCustomFieldDateSearch();
    }
    //alert(event.target.value)
    if (event.target.value == "assign_to") {
      this.toggleDropDownType = event.target.value;
      this.actionButton = "reset"
    }else if (event.target.value == "user_id") {
      this.toggleDropDownType = event.target.value;
      this.actionButton = "reset"
    }else if (event.target.value == "team_id") {
      this.toggleDropDownType = event.target.value;
      this.actionButton = "reset"
    }else if (event.target.value == "created_by") {
      this.toggleDropDownType = event.target.value;
      this.actionButton = "reset"
    }
    else if (event.target.value == "lead_type") {
      this.toggleDropDownType = event.target.value;
      this.actionButton = "reset"
    }
    else if (event.target.value == "lead_status") {
      this.toggleDropDownType = event.target.value;
      this.actionButton = "reset"
    }
    else if (event.target.value == "region") {
      this.toggleDropDownType = event.target.value;
      this.actionButton = "reset"
    }
    else if (event.target.value == "enquiry") {
      this.toggleDropDownType = event.target.value;
      this.actionButton = "reset"
    }
    else if (event.target.value == "currency") {
      this.toggleDropDownType = event.target.value;
      this.actionButton = "reset"
    }
    else if (event.target.value == "po quarter") {
      this.toggleDropDownType = event.target.value;
      this.actionButton = "reset"
    }
    else if (event.target.value == "po - fy") {
      this.toggleDropDownType = event.target.value;
      this.actionButton = "reset"
    } 
    else {
      // this.toggleDropDownType = '';
      // this.toggleDropDown = false;
      // this.actionButton = "search"

      // check whether for the key we have type of select or not
      console.log(this.filterArray)
      const selectedFilter = this.filterArray.find((filter: any) => filter.key === event.target.value);

      console.log(selectedFilter)
      this.selectedFilterType = this.fieldTypeIsDate(selectedFilter?.type)
        ? 'date'
        : this.fieldTypeIsSelect(selectedFilter?.type)
          ? 'select'
          : selectedFilter?.['type'] || 'text';
      console.log('selectedFilter',selectedFilter)
      if (selectedFilter && this.fieldTypeIsSelect(selectedFilter.type)) {
        this.isCustomDateFieldSearch = false;
        this.activeCustomDateFieldKey = '';
        this.toggleDropDownType = 'dynamic_dropdown';
        
        // Check if options already have key-value pair structure
        const options = selectedFilter.options || [];
        const hasKeyValuePairs = options.length > 0 && 
          options.every((opt: any) => opt.hasOwnProperty('key') && opt.hasOwnProperty('value'));
        
        if (hasKeyValuePairs) {
          // Options already have key-value pairs, use as is
          this.dynamicDropdownOptions = options;
        } else {
          // Transform options into key-value pairs
          this.dynamicDropdownOptions = options.map((opt: any) => {
            // If it's already an object with different structure, try to extract key-value
            if (typeof opt === 'object' && opt !== null) {
              return {
                key: opt.id || opt.key || opt.value || opt,
                value: opt.name || opt.label || opt.value || opt
              };
            } else {
              // If it's a primitive value, use it for both key and value
              return {
                key: opt,
                value: opt
              };
            }
          });
        }
        
        console.log('dynamicDropdownOptions:', this.dynamicDropdownOptions);
        this.dynamicDropDownKey = selectedFilter.key;
        this.dynamicDropdownSelection = '';
        this.dynamicDropdownPlaceholder = 'Select';
        this.toggleDropDown = true;
        this.actionButton = "reset";
      } else if (selectedFilter && this.fieldTypeIsDate(selectedFilter.type)) {
        this.isCustomDateFieldSearch = true;
        this.activeCustomDateFieldKey = newKey;
        this.filterType = newKey;
        this.selectedFilterType = 'date';
        this.SearchInput = '';
        this.toggleDropDownType = '';
        this.toggleDropDown = false;
        this.actionButton = 'reset';
        this.customFieldDateStart = new Date();
        this.customFieldDateEnd = new Date();
      } else {
        this.isCustomDateFieldSearch = false;
        this.activeCustomDateFieldKey = '';
        this.toggleDropDownType = '';
        this.toggleDropDown = false;
        this.actionButton = "search";
      }
    }
  }
  resetFilter() {
    const wasCustomDate = this.isCustomDateFieldSearch;
    this.actionButton = 'search';
    this.SearchInput = ""
    this.toggleDropDown = false;
    this.toggleDropDownType = "";
    this.isCustomDateFieldSearch = false;
    this.activeCustomDateFieldKey = '';

    this.filterType = ""
    this.dynamicDropdownSelection = '';
    this.dynamicDropdownPlaceholder = 'Select';
    this.searchFilter.emit("")
    this.ResetFilter.emit("reset")
    if (wasCustomDate) {
      this.DateFilter.emit({ dynamicFieldDateFilter: null });
    }
    this.mobileMenuVisible= false;
  }

  createNewGroup() {
    this.openList.emit();
    this.toggleExport = false;
  }

  openCustomerCaptureForm(): void {
    openCustomerActivityCaptureForm();
  }

  createMethod() {
    this.Create.emit();
    this.isActive = 'Add New'
    this.toggleExport = false;
  }

  getFilterValue() {
  const key = this.filterType;
  const query = (this.SearchInput || '').toString().trim();
  const payload: any = {};

  this.mobileMenuVisible = false;
  this.errorMsg = '';

  if (!key) {
    return this.setError('Please select a filter type');
  }

  const selected = this.filterArray.find((f: any) => f.key === key);
  const inputKind = this.fieldTypeIsDate(selected?.type)
    ? 'date'
    : this.fieldTypeIsSelect(selected?.type)
      ? 'select'
      : selected?.type || this.selectedFilterType || 'text';

  if (!query) {
    return this.setError('Please enter a value to search');
  }

  let isValid = true;
  let errorMessage = '';

  switch (inputKind) {
    case 'time':
      isValid = /^\d{1,2}:\d{2}(:\d{2})?$/.test(query);
      errorMessage = 'Enter a valid time';
      break;
    case 'date':
      if (isNaN(Date.parse(query))) {
        isValid = false;
        errorMessage = 'Invalid date format';
      } else {
        const inputDate = new Date(query);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        isValid = inputDate <= today;
        errorMessage = 'Future dates are not allowed';
      }
      break;
    case 'number':
      isValid = /^\d+$/.test(query);
      errorMessage = 'Only numeric values are allowed';
      break;
    case 'email':
      isValid = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(query);
      errorMessage = 'Please enter a valid email address';
      break;
    case 'mobile':
    case 'phone':
      isValid = /^\d{7,15}$/.test(query);
      errorMessage = 'Phone number must contain 7–15 digits';
      break;
    case 'id':
      isValid = /^\d+$/.test(query);
      errorMessage = 'Only numeric values are allowed';
      break;
    default:
      isValid = /^[A-Za-z0-9 _-]{1,100}$/.test(query);
      errorMessage = 'Only letters, numbers, spaces, _ and - are allowed';
      break;
  }

  if (!isValid) {
    return this.setError(errorMessage);
  }

  payload[key] = query;
  this.searchFilter.emit(payload);
  this.actionButton = 'reset';
}


  private setError(message: string) {
  this.errorMsg = message;
  this.toast.error(message);

  setTimeout(() => {
    this.errorMsg = '';
  }, 1500);
}
clearError() {
  this.errorMsg = '';
}
  exportExcel() {

    if(this.topBarTitle == 'User Logs') {
      this.ExportData.emit(this.displayedColumns);
      this.toggleExport = false;
      return;
    }

    if (this.filterCol.length == 0) {
      this.toast.error("Please select column")
      return;
    }
    this.ExportData.emit(this.filterCol);
    this.toggleExport = false;

  }
  applyFilter(event: any) {
    let filterValue = event.target.value;
  }
  onLeadDateRangeChange() {
    if (this.FilterdateStart && this.Filterdateend) {
      this.emitLeadDateRange();
    }
  }

  onCustomFieldDateRangeChange() {
    if (this.customFieldDateStart && this.customFieldDateEnd) {
      this.emitCustomFieldDateRange();
    }
  }

  /** lead_date (global toolbar range) — independent of Deadline / JSON date fields. */
  private emitLeadDateRange() {
    let start = (this.FilterdateStart != null) ? new Date(this.FilterdateStart.setHours(0, 0, 0, 0)) : this.FilterdateStart;
    let end = (this.Filterdateend != null) ? new Date(this.Filterdateend.setHours(0, 0, 0, 0)) : this.Filterdateend;
    const startd = moment(start).format("YYYY-MM-DD");
    const endb = moment(end).format("YYYY-MM-DD");
    if (startd !== "Invalid date" && endb !== "Invalid date") {
      this.DateFilter.emit({ startDate: startd, endDate: endb });
    }
    this.mobileMenuVisible = false;
  }

  /** Custom field stored in leads.fields JSON (e.g. deadline). */
  private emitCustomFieldDateRange() {
    const customKey = this.activeCustomDateFieldKey || this.filterType;
    if (!this.isCustomDateFieldSearch || !customKey) {
      return;
    }
    let start = (this.customFieldDateStart != null) ? new Date(this.customFieldDateStart.setHours(0, 0, 0, 0)) : this.customFieldDateStart;
    let end = (this.customFieldDateEnd != null) ? new Date(this.customFieldDateEnd.setHours(0, 0, 0, 0)) : this.customFieldDateEnd;
    const startd = moment(start).format("YYYY-MM-DD");
    const endb = moment(end).format("YYYY-MM-DD");
    if (startd !== "Invalid date" && endb !== "Invalid date") {
      this.DateFilter.emit({
        dynamicFieldDateFilter: {
          field: customKey,
          mode: 'range',
          startDate: startd,
          endDate: endb
        }
      });
    }
    this.mobileMenuVisible = false;
  }

  getImportedData(event: any) {
    this.importDataArray = event;

  }
  submitImport(event: any) {
    this.sendImportData.emit(event)
  }
  resetLeadDatePicker() {
    this.FilterdateStart = new Date();
    this.Filterdateend = new Date();
    if (this.mergeDateFilterPayloads) {
      this.DateFilter.emit({ startDate: null, endDate: null });
    } else {
      this.DateFilter.emit("");
    }
    this.ResetDateFilter.emit("reset");
  }

  resetCustomFieldDatePicker() {
    this.customFieldDateStart = new Date();
    this.customFieldDateEnd = new Date();
    this.DateFilter.emit({ dynamicFieldDateFilter: null });
  }


  openBulkFilter() {
    this.isActive = 'Filter'
    this.isOpen = true;
  }

  closeSidebar() {
    this.isOpen = false;
  }

  

  openSidebar() {
    this.isOpen = true;
  }



  applyBulkFilter() {
    const advanced_filters = this.filters.reduce((acc:any, filter:any) => {
      acc[filter.name.toLowerCase().replace(/ /g, '_')] = { 
        checked: filter.checked, 
        condition: filter.condition 
      };
      return acc;
    }, {});

    
    this.applyLeadBulkFilter.emit(advanced_filters);
    this.mobileMenuVisible = false

  }

  clearFilter() {
    this.filters.forEach((filter : any) => filter.checked = false);
    this.clearLeadBulkFilter.emit();
  }

  onFilterChange() {
    // Optionally handle changes when checkboxes are checked/unchecked
  }

  toggleMobileMenu (){
    this.mobileMenuVisible = !this.mobileMenuVisible;
  }
  @HostListener('window:resize', ['$event'])
    onResize(event: Event) {
    if (window.innerWidth > 1024 && this.mobileMenuVisible) {
      this.mobileMenuVisible = false;
    }
  }

  resetModalState(){
    this.isExcelImportOpen = false;
  }

  closeExcelImport() {
    if(this.modalRef){
      this.modalRef.close();
    }
    this.resetModalState();
  }

  openRemoveDuplicateModal(content: any) {
    this.modalRef = this.modalService.open(content, {
      centered: true,
      windowClass: 'remove-duplicates-modal remove-duplicates-modal--compact',
    });
  }

  connectOutlook() {
     this.connectCommunication.emit();
  }
  closeDuplicate() {
   this.modalService.dismissAll()
   this.resetFilter()
  }

}
